export default __webpack_public_path__ + "static/media/arrow-black.394fc6ee.svg";